import styled from 'styled-components';

export const LayoutWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const HeaderContainer = styled.header<{ $isCompact?: boolean }>`
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${({ $isCompact }) => ($isCompact ? '0.5rem 1rem' : '1rem')};
  background-color: ${({ theme }) =>
    theme.colors.backgroundDark ?? theme.colors.backgroundPrimary};
  flex-wrap: ${({ $isCompact }) => ($isCompact ? 'nowrap' : 'wrap')};
  gap: ${({ $isCompact }) => ($isCompact ? '0.5rem' : '1rem')};
  transition: all 0.3s ease;

  @media (max-width: 768px) {
    flex-direction: ${({ $isCompact }) => ($isCompact ? 'row' : 'column')};
    align-items: ${({ $isCompact }) => ($isCompact ? 'center' : 'stretch')};
  }
`;

export const LoginContainer = styled.div<{ $isCompact?: boolean }>`
  text-align: right;
  display: flex;
  flex-direction: ${({ $isCompact }) => ($isCompact ? 'row' : 'column')};
  align-items: ${({ $isCompact }) => ($isCompact ? 'center' : 'flex-end')};
  gap: ${({ $isCompact }) => ($isCompact ? '0.75rem' : '0.5rem')};
`;

export const WelcomeText = styled.p`
  color: ${({ theme }) => theme.colors.text.onDark ?? theme.colors.background};
  margin: 0;
  font-size: 1rem;

  @media (max-width: 480px) {
    font-size: 0.9rem;
  }
`;

export const Logo = styled.img<{ $isCompact?: boolean }>`
  width: ${({ $isCompact }) => ($isCompact ? '120px' : '200px')};
  height: auto;
  object-fit: contain;
  cursor: pointer;
  transition: width 0.3s ease;

  @media (max-width: 1024px) {
    width: ${({ $isCompact }) => ($isCompact ? '100px' : '180px')};
  }

  @media (max-width: 768px) {
    width: ${({ $isCompact }) => ($isCompact ? '90px' : '160px')};
  }

  @media (max-width: 480px) {
    width: ${({ $isCompact }) => ($isCompact ? '80px' : '140px')};
  }
`;

export const LogoVersionWrapper = styled.div<{ $isCompact?: boolean }>`
  display: flex;
  flex-direction: ${({ $isCompact }) => ($isCompact ? 'row' : 'column')};
  align-items: ${({ $isCompact }) => ($isCompact ? 'center' : 'flex-end')};
  gap: ${({ $isCompact }) => ($isCompact ? '0.5rem' : '0.25rem')};
`;

export const VersionText = styled.span`
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.text.disabled};
  font-weight: 500;
  letter-spacing: 0.5px;
  padding-right: 8px;
  cursor: pointer;
  transition: color 0.2s ease;
  user-select: none;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: underline;
  }

  &:active {
    color: ${({ theme }) => theme.colors.secondary};
  }

  @media (max-width: 480px) {
    font-size: 0.8rem;
  }
`;

export const MainContent = styled.main`
  flex: 1;
`;
